module.exports = __webpack_public_path__ + "img/roomcard_level3.109db547.png";